<template>
  <div id="employmentRate">
    <div class="employmentRateTitle">
      就业率占比
    </div>

    <div class="chartInstanceBox">
      <div id="chartInstance" ref="chartInstance" ></div>
      <div class="left2Bg">
        <div class="proportion">{{ employmentRateNum.toFixed(2)}}%</div>
        <div class="proportionText">数据占比</div>
      </div>
    </div>



  </div>
</template>

<script>
import { getEmploymentRateApi } from '@/utils/api'

export default {
  components: {
  },
  data() {
    return {
      employmentRate: [],
      employmentRateNum: 0
    }
  },
  mounted() {
    this.getEmploymentRate()

  },
  methods: {

    async getEmploymentRate(data) {
      await getEmploymentRateApi({
        ...data,
        size: 5
      }).then(res => {
        this.employmentRate = res.data.data
        var totalNumber = 0
        res.data.data.map(item => {
          totalNumber += item.value
        })
        this.employmentRateNum = (res.data.data[0].value / totalNumber * 100)?res.data.data[0].value / totalNumber * 100:0
        this.chartInstanceInit()
      })
    },

    chartInstanceInit() {
      const chartInstance = this.$echarts.init(this.$refs.chartInstance)
      const initOption = {
        tooltip: {
          trigger: 'item'
        },
       
        grid: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 0
        },
        series: [
          {
            type: 'pie',
            radius: ["54%", "70%"],
            avoidLabelOverlap: false,
            padAngle: 10,
            itemStyle: {
              normal: {
                borderRadius: 10,
                color: (list) => {
                  // 注意 ！！！！！ 这里的数组一定要和实际的类目长度相等或大于，不然会缺少颜色报错
                  var colorList = [
                    {
                      colorStart: '#291aeb',
                      colorCenter: '#258fff',
                      colorEnd: '#e8ffff'
                    },
                    {
                      colorStart: '#cf7c21',
                      colorCenter: '#ff8500',
                      colorEnd: '#e8ffff'
                    },

                  ]
                  return new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [{ //左、下、右、上
                    offset: 0,
                    color: colorList[list.dataIndex]['colorStart']
                  }, {
                    offset: 0.5,
                    color: colorList[list.dataIndex]['colorCenter']
                  }, {
                    offset: 1,
                    color: colorList[list.dataIndex]['colorEnd']
                  }])
                }
              }
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: this.employmentRate
          }
        ]
      };

      chartInstance.setOption(initOption)

    }
  }
};
</script>

<style lang="scss" scoped>
#employmentRate {
  padding-left: 41px;
  // margin-bottom: 50px;
}

.chartInstanceBox {
  position: relative;
  width: 319px;
  height: 300px;
  margin-left: 51px;
}

#chartInstance {
  width: 319px;
  height: 300px;

}

.left2Bg {
  width: 162px;
  height: 162px;
  background-image: url('../assets/left2Bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .proportion {
    font-size: 31px;
    // color: linear-gradient(0deg, #291AEB 0%, #258FFF 50.244140625%, #E8FFFF 100%);
    margin-bottom: 17px;
    background: linear-gradient(to right, #E8FFFF, #258FFF, #291AEB);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .proportionText {
    font-size: 19px;
    color: #FFFFFF;
  }
}

.employmentRateTitle {
  font-weight: bold;
  font-size: 28px;
  color: #0EE1F4;
  background: linear-gradient(179deg, #0EE1F4 0%, #0096FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1;
}
</style>